<template>
  <v-container class="pa-0">
    <app-header inside :numbers="!!number" :button="!number" :buttonAction="action">
      <template v-slot:title>{{ data.name }}</template>
      <template #buttonText>{{ number === maxStep ? "Next Step >>" : "Next Exercise" }}</template>
      <template v-if="number" #current-step>{{ number }}</template>
      <template v-if="maxStep" #max-step>{{ maxStep }}</template>
    </app-header>
    <v-divider></v-divider>
    <app-focus
      :button="number > 0"
      class="mt-9"
      @next-exercise="action"
      :backButton="$route.name !== 'exercise'"
      :backAction="backAction"
    >
      <template #text-focus>{{ data.focus }}</template>
      <template #buttonText>{{ number === maxStep ? "Next Step >>" : "Next Exercise" }}</template>
    </app-focus>
    <app-title class="mt-9 mb-4">
      <template #title>Directions</template>
      <template #text>{{ data.description }}</template>
    </app-title>
    <app-transcript-body
      class="mt-4"
      :stepUuid="data.uuid"
      :questions="data.question_group.questions"
      :question_group="data.question_group.uuid"
      @finished="onFinished"
      @reset="$emit('reset')"
      @already-finished="onAlreadyFinished"
    />
  </v-container>
</template>
<script>
import Header from "./../components/Header.vue";
import Focus from "./Focus.vue";
import Title from "./Title.vue";
import TranscriptBody from "./Transcript/TranscriptBody.vue";
import finishMixin from "@/mixins/finishMixin";

export default {
  components: {
    appHeader: Header,
    appFocus: Focus,
    appTitle: Title,
    appTranscriptBody: TranscriptBody,
  },
  mixins: [finishMixin],
  props: {
    data: {
      required: false,
      default: () => {},
      type: Object,
    },
    number: {
      required: false,
      default: 0,
      type: Number,
    },
    maxStep: {
      required: false,
      default: -1,
      type: Number,
    },
  },
  data() {
    return {
      finished: false,
    };
  },
  methods: {
    action() {
      this.$emit("next-exercise");
    },
    backAction() {
      this.$emit("prev-exercise");
    },
  },
};
</script>
